import { Link as v4Link } from 'react-router-dom';
import { AppLayoutContainer, type Brand } from '@zg-rentals/zrm-header-navigation';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import { isColandlordPath, RENTER_HUB_PATH } from '../constants/routeConstants';
import styledComponents from 'styled-components';
import { useIsInMobileWebView } from '../utils/mobileHandoffFunctions';

const ComponentStyles = styledComponents.div<{ isRenterHub?: boolean }>`
  .HeaderNav-mobile-menubutton {
    display: none !important;
  }
  ${
    // TODO: This is necessary until there is a Rachel specific HeaderNav
    // It hides nav section to left of logo (hides Properties/Messages) and notification icon to the right of logo
    (props) =>
      props.isRenterHub &&
      `
    .HeaderNavigation-sectionLeft {
      visibility: hidden;
    }

    .SectionRight-notificationCenter {
      display: none;
    }
  `
  }
`;

type Props = {
  children?: React.ReactNode;
  isLoading?: boolean;
};

function LeasesHeaderNav(props: Props) {
  const { isLoading, children } = props;
  const inMobileWebView = useIsInMobileWebView();
  const { user } = useRentalManagerUser();
  const isRenterHub = global['location'] && location.pathname.includes(RENTER_HUB_PATH);
  const isColandlord = global['location'] && isColandlordPath(location.pathname);
  const { isRocketshipCustomerOnly } = user;
  const useAltLogo = !isRocketshipCustomerOnly && !isRenterHub;

  if (inMobileWebView) {
    return children;
  }

  return (
    user && (
      <ComponentStyles isRenterHub={isRenterHub}>
        <AppLayoutContainer
          useLeftNav={!isRenterHub}
          isLoading={isRenterHub || isColandlord ? false : isLoading}
          // legacy
          altLogo={useAltLogo}
          brand={'zillow' as Brand}
          reactRouterLink={v4Link}
          useRelativePaths={false}
          host={typeof window !== 'undefined' ? window.location.host : undefined}
          userModel={user}
          pathname={global['location'] && location.pathname}
          logoPathOverride={isRenterHub ? '/' : null}
          {...props}
        >
          {children}
        </AppLayoutContainer>
      </ComponentStyles>
    )
  );
}

export default LeasesHeaderNav;
